<template>
  <div>
    <div class="ultimasAberturas">
      <carousel
        :autoplayTimeout="3500"
        :loop="true"
        :autoplay="true"
        :paginationEnabled="false"
        :scrollPerPage="false"
        :paginationSize="1"
        :perPageCustom="[
          [0, 3],
          [768, 4],
          [1024, 6],
          [1390, 8],
          [1750, 11],
        ]"
      >
        <slide
          v-for="(item, index) in itens"
          :key="index"
          class="sliderBox"
          :style="{ backgroundColor: generateRandomColor(index) }"
        >
          <div class="conteudo-slider">
            <div class="conteudo-imagens">
              <div class="text-center">
                <img :src="item.imgProduto" class="imgProduto" />
                <h6 class="mt-2">há 1 minuto</h6>
              </div>

              <div class="text-center">
                <img :src="item.imgCaixa" class="imgCaixa" />
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <div class="row flex justify-items-center">
      <div class="col">
        <span
          class="tituloAberturas m-2 p-1 font-weight-bold border border-dark rounded flag"
        >
          <i class="fa fa-circle text-danger" />
          ÚLTIMAS COMPRAS
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Tabs, TabPane, Button } from '@/components';
import { Carousel, Slide } from 'vue-carousel';
import service from './../../../services';
import Avatar from 'vue-avatar';

export default {
  data() {
    return {
      tema: this.$funcoesTema.getTema(),
      carregando: false,
      itens: [],
      colorsCache: {},
    };
  },
  methods: {
    getTema() {
      if (!this.tema) {
        this.tema = JSON.parse(localStorage.getItem('tema'));
      }
    },
    buscarDados() {
      this.carregando = true;
      service.getAll('Caixa', {}, 'UltimasAbertas?idEmpresa=null').then(res => {
        this.itens = [];
        res.data.forEach(element => {
          this.itens.push(element);
        });
        console.log(this.itens);
        this.carregando = false;
      });
    },
    generateRandomColor(index) {
      const predefinedColors = [
        'rgba(255, 165, 0, 0.25)',
        'rgba(128, 128, 128, 0.25)',
        'rgba(0, 0, 255, 0.25)',
        'rgba(128, 0, 128, 0.25)',
        'rgba(128, 128, 128, 0.25)',
      ];

      if (this.colorsCache[index]) {
        return this.colorsCache[index];
      }

      // Escolha uma cor aleatória da lista
      const color = predefinedColors[index % predefinedColors.length];
      this.colorsCache[index] = color;
      return color;
    },

    isRedOrGreen(color) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      const isRed = r > 150 && g < 100 && b < 100;
      const isGreen = g > 150 && r < 100 && b < 100;

      return isRed || isGreen;
    },
  },
  mounted() {
    this.buscarDados();
    this.getTema();
  },
  components: {
    Card,
    Tabs,
    TabPane,
    Button,
    Carousel,
    Slide,
    Avatar,
  },
};
</script>

<style scoped>
.flag {
  background-color: #111 !important;
}
.ultimasAberturas {
  text-align: center;
  border-radius: 0px 0px 15px 15px;
  padding: 4px 0px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.sliderBox {
  padding: 5px;
  margin: 0.5rem 0.1rem;
  font-size: 11px;
  height: 90px;
  border-radius: 5px;
  border: solid 1px #575757;
}

.conteudo-imagens {
  margin-top: -15px;
  max-height: 105px;
}
.imgProduto {
  max-height: 60px;
  margin-top: 15px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.imgCaixa {
  max-height: 60px;
  margin-top: -30px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.imgCaixa {
  opacity: 0;
}
.sliderBox:hover .imgProduto {
  transform: translateY(100%) scale(0);
  opacity: 0;
  transition: transform 0.3s ease, opacity 0s ease;
}
.sliderBox:hover .imgCaixa {
  opacity: 1;
  animation: grow-shrink 1s ease-in-out forwards;
}
.sliderBox:hover .avatarSwiper {
  transform: translateX(-10%) translateY(20%) scale(1.2);
}
.sliderValor {
  font-size: 10px;
  border: none;
}
.avatarSwiper {
  transition: transform 0.3s ease;
}

/*DESK*/
@media all and (min-width: 480px) {
}

/*MOBILE*/

@keyframes grow-shrink {
  0% {
    transform: translateY(0) scale(0);
  }
  20% {
    transform: translateY(-100%) scale(1);
  }
  40% {
    transform: translateY(-100%) scale(1.3);
  }
  60% {
    transform: translateY(-100%) scale(1);
  }
  80% {
    transform: translateY(-100%) scale(1.05);
  }
  100% {
    transform: translateY(-100%) scale(1);
  }
}
</style>
